export class OrderImportModel {
    counter: number = 0;
    orderId: number = 0;
    consecutiveOrder: number = 0;
    articleCode: number = 0;
    articleName: string = "";
    quantityInitial: number = 0;
    unitValue?: number = 0;

    constructor(
        counter: number = 0,
        orderId: number = 0,
        consecutiveOrder: number = 0,
        articleCode: number = 0,
        articleName: string = "",
        quantityInitial: number = 0,
        unitValue: number = 0
    ) {
        this.counter = counter;
        this.orderId = orderId;
        this.consecutiveOrder = consecutiveOrder;
        this.articleCode = articleCode;
        this.articleName = articleName;
        this.quantityInitial = quantityInitial;
        this.unitValue = unitValue;
    }
}